import { createFirebaseAuthAxios } from "@/lib/firebase/authAxios";
import { customerShopService } from "@/features/shop/customer/customer-shop.service";
import type { CustomerCart } from "@/features/shop/types/customer-shop";
import {
  clearLocalCustomerCart,
  getLocalCustomerCart,
} from "@/features/shop/cart/customer-cart-storage";

const api = createFirebaseAuthAxios();
const shopApi = customerShopService(api);

const emptyCartResponse = {
  success: true,
  data: null as unknown as CustomerCart,
};

export async function syncLocalCustomerCartToServer(options?: {
  loading?: boolean;
  role?: string;
}) {
  if (options?.loading || options?.role !== "customer") {
    return emptyCartResponse;
  }

  const localCart = getLocalCustomerCart();
  if (!localCart || localCart.items.length === 0) {
    return emptyCartResponse;
  }

  const response = await shopApi.syncCart({
    items: localCart.items,
  });
  clearLocalCustomerCart();
  return response;
}
